import { RootState } from "../../store/types";
import { AsyncEntity } from "../_shared/action-model-async";
import { FeaturesModel } from "../../api";

export const getFeatureSettings = (state: RootState): AsyncEntity<FeaturesModel> => state.features.entityField;
export const getDistance = (state: RootState): boolean => getFeatureSettings(state).distanceFilteringEnabled;